import PropTypes from 'prop-types'
import classNames from 'classnames'

const ProductItem = ({
  name,
  image,
  url,
  unit,
  price
}) => {
  const promotional = price.from

  const promotionalTag = () => (
    <span className="price-from">
      R$ { promotional.integers },{ promotional.decimals } { unit }
    </span>
  )

  const priceClassName = classNames({
    price: !promotional,
    'price-to': promotional
  })

  const priceTag = () => (
    <div className="price-tag hide-offline">
      { promotional && promotionalTag() }

      <span className={ priceClassName }>
        R$ { price.to.integers },{ price.to.decimals } { unit }
      </span>
    </div>
  )

  return (
    <li className="list-item">
      <a className="item-product" href={ url }>
        <img className="thumb" src={ image } />
        <div className="item-product-info">
          <h4 className="name">{ name }</h4>
          { priceTag() }
        </div>
      </a>
    </li>
  )
}

ProductItem.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  url: PropTypes.string.isRequired,
  unit: PropTypes.string,
  price: PropTypes.shape({
    from: PropTypes.shape({
      integers: PropTypes.string,
      decimals: PropTypes.string
    }),
    to: PropTypes.shape({
      integers: PropTypes.string.isRequired,
      decimals: PropTypes.string.isRequired
    })
  })
}

export default ProductItem
